import React from 'react'
import PropTypes from 'prop-types'
import Synonyms from '../../config/Synonyms'
import { AppliedTooltip as Tooltip, BaseSpan, PopoverContainer, SynonymSuggestions } from '../AppliedTooltip/AppliedTooltip'

class MasculineSpan extends React.Component {
    findSynonyms(word) {
        const wordText = word[0].props.text
            .toLowerCase()
            .replace(/[.,/#!$^&*;:{}=\-_`~()]/g, '')
        return Object.keys(Synonyms).includes(wordText)
            ? Synonyms[wordText].synonyms
            : []
    }

    updateWord(synonym) {
        const { start } = this.props.children[0].props
        const { decoratedText } = this.props
        this.props.replaceText({
            synonym,
            blockKey: this.props.children[0].props.block.getKey(),
            start,
            end: start + decoratedText.length,
        })
    }

    popoverTop() {
        const synonyms = this.findSynonyms(this.props.children)
        return (
            <PopoverContainer title="Masculine text" color="#FF6238">
                <div>
                    "{this.props.children[0].props.text.replace(
                        /\b[-.,()&$#![\]{}"']+\B|\B[-.,()&$#![\]{}"']+\b/g,
                        '',
                    )}" is a masculine coded word.&nbsp;
                    {synonyms.length > 1 ? (
                        <span>
                            If you have too many, maybe try one of these
                            alternatives:
                        </span>
                    ) : null}
                </div>
                {synonyms.length > 0 
                    ? <SynonymSuggestions 
                        synonyms={synonyms} 
                        onClick={this.updateWord.bind(this)} 
                    />
                    : null
                }
            </PopoverContainer>
        )
    }

    render() {
        return (
            <span>
                <Tooltip 
                    popoverContent={this.popoverTop()}
                    disabled={!this.props.user.userId}
                >
                    <BaseSpan
                        offsetKey={this.props.offsetKey}
                        disabled={!this.props.user.userId}
                        color="#FFCBAB"
                        borderColor="#FF6238"
                    >
                        {this.props.children}
                    </BaseSpan>
                </Tooltip>
            </span>
        )
    }
}

MasculineSpan.propTypes = {
    children: PropTypes.array,
}

export default MasculineSpan
